import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Etage } from 'app/models/etage.model';

@Injectable({
  providedIn: 'root'
})
export class EtageService {

  private API_URL = environment.API_URL;
  private MODEL_URL = 'etages';

  constructor(private http: HttpClient) { }

  getEtages(dossier_intervention_id: number): Observable<Etage[]>{
    return this.http.get<Etage[]>(this.API_URL + 'dossiers-interventions/' + dossier_intervention_id + '/' + this.MODEL_URL).pipe(
      catchError(err => throwError(err))
    );
  }
  getEtagesAvecCroquis(dossier_intervention_id: number): Observable<Etage[]>{
    return this.http.get<Etage[]>(this.API_URL + 'dossiers-interventions/' + dossier_intervention_id + '/' + this.MODEL_URL, {params: {includes: ['croquis']}}).pipe(
      catchError(err => throwError(err))
    );
  }

  store(etage: Etage): Observable<Etage>{
    return this.http.post<Etage>(this.API_URL + 'dossiers-interventions/' + etage.dossier_intervention_id + '/' + this.MODEL_URL, etage).pipe(
      catchError(err => throwError(err))
    );
  }

  delete(id: number): Observable<any> {
    return this.http.delete(this.API_URL + this.MODEL_URL + '/' + id).pipe(
      catchError(err => throwError(err))
    );
  }
}
